import { useEffect, RefObject } from "react";

/**
 * Auto-resizes a textarea to fit its content whenever `dep` changes.
 * Sets height to "auto" first to allow shrinking, then to scrollHeight.
 */
export function useAutoResize(ref: RefObject<HTMLTextAreaElement | null>, dep: unknown): void {
  useEffect(() => {
    const ta = ref.current;
    if (!ta) return;
    ta.style.height = "auto";
    ta.style.height = `${ta.scrollHeight}px`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dep]);
}
